var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPage1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 57,
    viewBox: "0 0 44 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6872 6.6712C38.7481 6.55453 28.7306 5.79946 23.2501 0.977863C22.5386 0.341175 21.4622 0.341175 20.7506 0.977863C15.2701 5.80226 5.25265 6.55733 2.31265 6.6712C1.31545 6.71091 0.528901 7.53336 0.533713 8.53133V23.7157C0.533327 37.6664 8.58062 50.3655 21.1958 56.3218C21.7054 56.5613 22.2953 56.5613 22.8049 56.3218C35.4008 50.3436 43.4394 37.6583 43.467 23.7157V8.53133C43.4719 7.53336 42.6853 6.71091 41.6881 6.6712H41.6872ZM41.6004 23.7157C41.575 36.9416 33.9437 48.9732 21.9901 54.6334C10.0285 48.9854 2.39875 36.9437 2.40038 23.7157L2.38731 8.536C5.48225 8.41373 16.042 7.60267 22.0172 2.376C27.9504 7.59893 38.4896 8.41187 41.6004 8.536V23.7157Z",
    fill: "url(#paint0_linear_443_6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9952 5.44666C16.2688 8.48372 10.1984 9.67185 5.93962 10.1348C4.99086 10.234 4.26955 11.0326 4.26709 11.9865V23.6747C4.27259 35.484 10.7295 46.3468 21.1007 51.9948C21.6627 52.2946 22.3372 52.2946 22.8992 51.9948C33.2779 46.3545 39.738 35.487 39.7338 23.6747V11.9865C39.7342 11.0308 39.0127 10.2291 38.0622 10.1292C33.8006 9.66252 27.7283 8.47812 23.0028 5.44199C22.3915 5.04679 21.6047 5.04861 20.9952 5.44666ZM37.8671 11.9865V23.6747C37.871 34.8021 31.7852 45.0394 22.0079 50.3521L22.454 51.1725L21.9874 50.3531C12.2197 45.0307 6.13913 34.7983 6.13376 23.6747L6.13936 11.9865C10.5998 11.5021 16.9726 10.2459 22.0004 7.01279C27.0255 10.2449 33.3992 11.5012 37.8671 11.9865Z",
    fill: "url(#paint1_linear_443_6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86667 15.2364C12.5141 14.7984 15.1181 14.1294 17.6488 13.2372C18.1253 13.0571 18.3694 12.5281 18.1971 12.0487C18.0249 11.5692 17.5001 11.3164 17.0179 11.4807C14.5897 12.3359 12.0913 12.9764 9.5512 13.3949C8.65463 13.5463 7.99871 14.3234 8 15.2327V20.1C8 20.6155 8.41787 21.0333 8.93333 21.0333C9.4488 21.0333 9.86667 20.6155 9.86667 20.1V15.2364Z",
    fill: "url(#paint2_linear_443_6)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0672 14.5V17.3485C20.0665 17.4505 19.0892 17.7154 18.1739 18.1325L17.6792 17.2767C17.5136 16.9855 17.2048 16.8054 16.8699 16.8046C16.535 16.8039 16.2253 16.9827 16.0585 17.2731C15.8917 17.5635 15.8933 17.9211 16.0627 18.21L16.5592 19.0696C15.7442 19.658 15.0289 20.3733 14.4405 21.1883L13.5809 20.6917C13.292 20.5223 12.9344 20.5208 12.644 20.6876C12.3536 20.8544 12.1748 21.164 12.1756 21.499C12.1763 21.8339 12.3564 22.1427 12.6476 22.3083L13.5035 22.8029C13.086 23.7181 12.8211 24.6955 12.7195 25.6963H10.8005C10.2851 25.6963 9.86719 26.1141 9.86719 26.6296C9.86719 27.1451 10.2851 27.5629 10.8005 27.5629H12.7148C12.8169 28.5636 13.0817 29.5409 13.4988 30.4563L12.6429 30.9509C12.3518 31.1165 12.1716 31.4253 12.1709 31.7602C12.1702 32.0952 12.3489 32.4048 12.6394 32.5716C12.9298 32.7384 13.2873 32.7369 13.5763 32.5675L14.4359 32.0709C15.0242 32.8873 15.7399 33.6039 16.5555 34.1933L16.0589 35.0529C15.8895 35.3419 15.8879 35.6994 16.0548 35.9898C16.2216 36.2803 16.5312 36.459 16.8661 36.4583C17.2011 36.4576 17.5099 36.2774 17.6754 35.9863L18.1701 35.1304C19.0855 35.5475 20.0628 35.8123 21.0634 35.9144V37.8333C21.0634 38.3488 21.4813 38.7667 21.9968 38.7667C22.5122 38.7667 22.9301 38.3488 22.9301 37.8333V35.92C23.9308 35.8179 24.9081 35.5531 25.8234 35.136L26.3181 35.9919C26.4837 36.283 26.7925 36.4632 27.1274 36.4639C27.4623 36.4646 27.772 36.2859 27.9388 35.9954C28.1056 35.705 28.104 35.3475 27.9346 35.0585L27.4381 34.1989C28.2546 33.6103 28.9712 32.8943 29.5605 32.0784L30.4201 32.5749C30.709 32.7443 31.0666 32.7459 31.357 32.5791C31.6474 32.4123 31.8262 32.1026 31.8255 31.7677C31.8247 31.4328 31.6446 31.1239 31.3534 30.9584L30.4976 30.4637C30.9147 29.5484 31.1795 28.5711 31.2816 27.5704H33.2005C33.716 27.5704 34.1338 27.1525 34.1338 26.6371C34.1338 26.1216 33.716 25.7037 33.2005 25.7037H31.2862C31.1846 24.703 30.9197 23.7256 30.5022 22.8104L31.3581 22.3157C31.6493 22.1502 31.8294 21.8413 31.8301 21.5064C31.8309 21.1715 31.6521 20.8619 31.3617 20.695C31.0712 20.5282 30.7137 20.5298 30.4248 20.6992L29.5652 21.1957C28.9768 20.3794 28.2612 19.6628 27.4456 19.0733L27.9421 18.2137C28.1115 17.9248 28.1131 17.5673 27.9463 17.2768C27.7794 16.9864 27.4698 16.8076 27.1349 16.8084C26.8 16.8091 26.4911 16.9892 26.3256 17.2804L25.8309 18.1363C24.9156 17.7191 23.9383 17.4543 22.9376 17.3523V14.5C22.9376 13.9845 22.5197 13.5667 22.0042 13.5667C21.4888 13.5667 21.0709 13.9845 21.0709 14.5H21.0672ZM29.4672 26.6333C29.4672 30.7571 26.1242 34.1 22.0005 34.1C17.8768 34.1 14.5339 30.7571 14.5339 26.6333C14.5339 22.5096 17.8768 19.1667 22.0005 19.1667C26.1223 19.1713 29.4625 22.5115 29.4672 26.6333Z",
    fill: "url(#paint3_linear_443_6)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2004 24.7667C19.7159 24.7667 20.1338 24.3488 20.1338 23.8333C20.1338 23.3179 19.7159 22.9 19.2004 22.9C18.685 22.9 18.2671 23.3179 18.2671 23.8333C18.2671 24.3488 18.685 24.7667 19.2004 24.7667Z",
    fill: "url(#paint4_linear_443_6)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1335 31.3C20.649 31.3 21.0669 30.8821 21.0669 30.3667C21.0669 29.8512 20.649 29.4333 20.1335 29.4333C19.6181 29.4333 19.2002 29.8512 19.2002 30.3667C19.2002 30.8821 19.6181 31.3 20.1335 31.3Z",
    fill: "url(#paint5_linear_443_6)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8005 26.6333C25.316 26.6333 25.7338 26.2155 25.7338 25.7C25.7338 25.1845 25.316 24.7667 24.8005 24.7667C24.2851 24.7667 23.8672 25.1845 23.8672 25.7C23.8672 26.2155 24.2851 26.6333 24.8005 26.6333Z",
    fill: "url(#paint6_linear_443_6)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_443_6",
    x1: 43.4671,
    y1: 56.5032,
    x2: 0.533691,
    y2: 56.5032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FA365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15545C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_443_6",
    x1: 39.7338,
    y1: 52.2211,
    x2: 4.26709,
    y2: 52.2211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FA365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15545C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_443_6",
    x1: 18.2523,
    y1: 21.0336,
    x2: 8,
    y2: 21.0336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FA365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15545C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_443_6",
    x1: 34.1338,
    y1: 38.7674,
    x2: 9.86719,
    y2: 38.7674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FA365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15545C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_443_6",
    x1: 20.1338,
    y1: 24.7667,
    x2: 18.2671,
    y2: 24.7667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FA365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15545C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_443_6",
    x1: 21.0669,
    y1: 31.3,
    x2: 19.2002,
    y2: 31.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FA365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15545C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_443_6",
    x1: 25.7338,
    y1: 26.6334,
    x2: 23.8672,
    y2: 26.6334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FA365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15545C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage1);
export default __webpack_public_path__ + "static/media/Page 1.73202318d1a042da833fbe5bb3af1ef5.svg";
export { ForwardRef as ReactComponent };